<template>
  <div class="appBox">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created(){
    document.addEventListener('DOMContentLoaded', ()=> {
        this.redirectByDevice();
    });
  },
  methods: {
    getDeviceType() {
        const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        // 如果屏幕宽度小于等于768px，则认为是移动端
        return screenWidth <= 768 ? 'mobile' : 'pc';
    },
    getPcUrl() {
        const hostname = window.location.hostname;
        const pcUrlMap = {
            'm.aiservhub.com': process.env.VUE_APP_NEW_PC,
            'm.quickapp.cn': process.env.VUE_APP_PC,
            'test.m.wankamall.com': process.env.VUE_APP_NEW_PC,
            'test.m.so-quick.cn': process.env.VUE_APP_PC,
        };
        return pcUrlMap[hostname] || process.env.VUE_APP_PC;
    },
    redirectByDevice() {
        const deviceType = this.getDeviceType();
        // 如果是PC端但访问的是移动端URL，则跳转到PC端URL
        if (deviceType === 'pc') {
          const currentUrl = window.location.pathname;
          const pcUrl = this.getPcUrl();
          if(currentUrl.includes('/active/developersConference') || currentUrl.includes('/commonGameProblem')){
            // 去指定页面
            window.location.href = pcUrl + window.location.pathname + window.location.search; 
          }else{
            // 去首页
            window.location.href = pcUrl;
          }
        }
    }
  }
};
</script>
<style lang="scss">
body {
  height: 100%;
  color: #333;
}
</style>
